module.exports = __webpack_public_path__ + "58e9f49f6a0990fdfba134c79685dcdf.svg";